module.exports = __webpack_public_path__ + "img/zalopay.94da3299.png";